import * as yup from 'yup'

export const filterSchema = yup.object({
    dataDe: yup
        .mixed<string>()
        .concat(yup.date())
        .transform((curr, orig) => (orig === '' ? null : curr))
        .nullable(),
    dataAte: yup
        .mixed<string>()
        .concat(yup.date())
        .transform((curr, orig) => (orig === '' ? null : curr))
        .nullable(),
    ufDetran: yup.string(),
    tipoOperacao: yup.string(),
    nomeUsuario: yup.string(),
    cpf: yup.string(),
    email: yup.string().email('Digite um e-mail válido'),
    acessoPerfil: yup
        .string()
        .transform(value => (value === '' ? null : value))
        .nullable()
})
